import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

/** Utilities */
import { decryptUrlData } from "../../../../../services/CryptoService";

/** Common Components */
import Iconify from "../../../../../layouts/components/iconify/iconify";
import IconButton from "../../../../../components/ui/iconbutton/IconButton";
import SidebarModal from "../../../../../components/ui/sidebarModel/SidebarModel";

/** Lazily Loaded Components */
import SynergyTasks from "./features/synergyTask/SynergyTasks";
import EditSynergyDescription from "./editSynergy/EditProjectSynergy";
import SynergyComments from "./features/synergyComments/SynergyComments";
import SynergyAttachments from "./features/synergyAttachments/SynergyAttachments";
import RefrenceSynergyTaskgrid from "./RefrenceSynergyTaskgrid";

/** RTK Query */
import { useLazyGetSynergyDetailsBySynergyIdQuery, useUpdateProjectSynergyMutation } from "../../../../../app/services/projectSynergyAPI";

/** CSS Files */
import "./EditSynergy.scss";
import formatDate from "../../../../../lib/formatDate";
import CenterModel from "../../../../../components/ui/centerModel/CenterModel";
import SynergyDescription from "./features/SynergyDescription/SynergyDescription";
import ToastService from "../../../../../services/toastService/ToastService";
import CreateTask from "../../../../task/CreateTask";

const EditSynergy = () => {
  const [showModal, setShowModal] = useState(false);
  const [editSynergy, setEditSynergy] = useState();
  const [showPopup, setShowPopup] = useState(false);
  const [activeSection, setActiveSection] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [title, setTitle] = useState("Synergy Title");
  const [showCenterPopup, setShowCenterPopup] = useState(false);
  const [showCreatTaskPopup, setShowCreatTaskPopup] = useState(false);

  const closeCenterPopup = () => {
    setShowCenterPopup(false);
    setIsEditing(false)
  };

  const handleOpenCenterPopup = () => {
    setShowCenterPopup(true);
  };


  const EditSynergyOpenPopup = () => {
    handleOpenCenterPopup();
    setIsEditing(true);
  }

  const EditSynergyClosePopup = () => {
    closeCenterPopup(false);
  }

  const { id } = useParams();
  const synergyData = id ? decryptUrlData(id) : null;
  const synergyId = synergyData.SynergyID;
  const projectId = synergyData.projectId;

  // API Calls
  const [
    getSynergyDetailsBySynergyId,
    {
      isFetching: isgetSynergyDetailsBySynergyIdFetching,
      isSuccess: isgetSynergyDetailsBySynergyIdFetched,
      data: getSynergyDetailsBySynergyIdData,
    },
  ] = useLazyGetSynergyDetailsBySynergyIdQuery();

  const [updateProjectSynergy, {
    isSuccess: isupdateProjectSynergySuccess,
    data: updateProjectSynergyData
  },] = useUpdateProjectSynergyMutation();

  useEffect(() => {
    if (synergyId) {
      getSynergyDetailsBySynergyId(synergyId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [synergyId]);

  useEffect(() => {
    if (
      !isgetSynergyDetailsBySynergyIdFetching &&
      isgetSynergyDetailsBySynergyIdFetched &&
      getSynergyDetailsBySynergyIdData
    ) {
      setEditSynergy(getSynergyDetailsBySynergyIdData);
      setTitle(getSynergyDetailsBySynergyIdData.title);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    isgetSynergyDetailsBySynergyIdFetching,
    isgetSynergyDetailsBySynergyIdFetched,
    getSynergyDetailsBySynergyIdData,
  ]);

  const closePopup = () => {
    setShowPopup(false);
    getSynergyDetailsBySynergyId(synergyId);
  };

  const togglePopup = () => {
    setShowPopup(!showPopup);
  };

  const handleSaveDescription = (updatedDescription) => {
    const request = {
      synergyID: synergyId,
      projectId: editSynergy?.projectId,
      synergyTypeID: editSynergy?.synergyTypeID,
      title: editSynergy?.title,
      priorityId: editSynergy?.priorityID,
      reportedBy: editSynergy?.reportedBy,
      description: updatedDescription,
      benefit: editSynergy?.benefit,
      status: editSynergy?.status,
      moduleIds: editSynergy?.projectModuleIDs,
      businessValue: editSynergy?.businessValue,
      considerations: editSynergy?.considerations,
      expectedOutcomes: editSynergy?.expectedOutcomes,
      proposedBy: editSynergy?.proposedBy,
      reasonForChange: editSynergy?.reasonForChange,
      submittedDate: editSynergy?.submittedDate,
      acceptanceCriteria: editSynergy?.acceptanceCriteria,
      userGoal: editSynergy?.userGoal,

    }
    updateProjectSynergy(request);
  };

  useEffect(() => {
    if (isupdateProjectSynergySuccess && updateProjectSynergyData) {
      ToastService.success(updateProjectSynergyData.errorMessage);
      getSynergyDetailsBySynergyId(synergyId);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isupdateProjectSynergySuccess, updateProjectSynergyData]);
  // const handleEditTitle = () => {
  //   setEditedTitle(title); // Set input value to current title
  //   setIsEditingTitle(true);
  // };

  // const handleSaveTitle = () => {
  //   setTitle(editedTitle); // Save new title
  //   setIsEditingTitle(false);
  // };

  const handleOpenPopup = () => {
    setShowPopup(true);
  };

  // const handleCancelEdit = () => {
  //   setEditedTitle(title); // Reset input to previous title
  //   setIsEditingTitle(false);
  // };

  const handleClick = (section) => {
    setActiveSection((prev) => (prev === section ? null : section));
  };

  const handleClose = () => {
    setActiveSection(null);
  };
  const handleModal = () => {
    setShowModal(!showModal);
  };
  const handleToggleModal = () => {
    setShowCreatTaskPopup(!showCreatTaskPopup);
  };


  return (
    <div
      className={`center-top-space edit-synergy ${activeSection ? "expanded" : ""
        }`}
    >
      <div className="left-section">
        <div className="edit-synergy-card">
          <div className="edit-synergy-header-section">
            <div className="header-left-section">
              <div className="edit-synergy-id">
                {editSynergy?.synergyTypeName + '' + ':'}
              </div>
              <div className="section-title">
                {/* {isEditingTitle ? (
                  <div className="editable-title">
                    <input
                      type="text"
                      value={editedTitle}
                      onChange={(e) => setEditedTitle(e.target.value)}
                      className="title-input"
                      maxLength={50}
                    />
                    <div className="edit-buttons">
                      <button className="save-btn" onClick={handleSaveTitle}>
                        <Iconify icon="material-symbols:check" />
                      </button>
                      <button className="cancel-btn" onClick={handleCancelEdit}>
                        <Iconify icon="material-symbols:close" />
                      </button>
                    </div>
                  </div>
                ) : (
                  <span onClick={handleEditTitle}>{title}</span>
                )} */}
                {editSynergy?.title}
              </div>
            </div>
            <div className="header-right-section">
              <div className="edit-synergy-buttons">
                <IconButton
                  variant="contained"
                  icon="tdesign:task-add"
                  shape="square"
                  className="icon-btn comments-btn"
                  size={"small"}
                  onClick={() => handleToggleModal()}
                />
                <IconButton
                  variant="contained"
                  icon="ix:attach"
                  shape="square"
                  className="icon-btn comments-btn"
                  size={"small"}
                  onClick={() => handleModal()}
                />
                <IconButton
                  variant="contained"
                  icon="mingcute:comment-fill"
                  shape="square"
                  className="icon-btn comments-btn"
                  size={"small"}
                  onClick={() => handleClick("comment")}
                />
                <IconButton
                  variant="contained"
                  icon="iconoir:task-list"
                  shape="square"
                  className="icon-btn tasks-btn"
                  size={"small"}
                  onClick={() => handleClick("task")}
                />
              </div>
            </div>
            <div className="edit-taskdescription-icon">
              <button
                type="submit"
                className="btn edit-btn"
                onClick={handleOpenPopup}
              >
                <Iconify icon="line-md:pencil" />
              </button>
            </div>
            <CenterModel
              showModal={showModal}
              handleToggleModal={handleModal}
              modalTitle={"Attach Task"}
              modelSizeClass="w-45"
            >
              <RefrenceSynergyTaskgrid
                projectId={projectId}
                synergyId={synergyId}
                onClose={handleModal}
                onSuccess={handleModal}
              />
            </CenterModel>

            <SidebarModal
              isOpen={showCreatTaskPopup}
              onClose={handleToggleModal}
              modalTitle="Add Synergy Task"
              modalSize="w-50"
              backdropClosable={false}
            >
              <CreateTask
                onClose={handleToggleModal}
                projectId={projectId}
                synergyId={synergyId}
                typeId={1}
              />
            </SidebarModal>

            <SidebarModal
              isOpen={showPopup}
              onClose={closePopup}
              modalTitle="Edit Synergy Description"
              modalSize="w-65"
              defaultPosition="left"
              className={"edit-task-ck edit-synergy-sidebar"}
            >
              {showPopup && (
                <EditSynergyDescription
                  editsynergy={editSynergy}
                  togglePopup={togglePopup}
                  closePopup={closePopup}
                  synergyId={synergyId}
                />
              )}
            </SidebarModal>
          </div>
          <div className="edit-synergy-content-section">
            <div className="edit-synergy-container">
              <div className="cards-container">
                {/* Basic Details */}
                <div className="synergy-content-card normal-form">
                  <div className="row flex-wrap">


                    <div className="synergy-data col-12">
                      <h2 className="lable">
                        Synergy Title <span>:</span>
                      </h2>
                      <p className="value">{editSynergy?.title}</p>
                    </div>
                    <div className={`synergy-data ${activeSection ? "col-12" : "col-6"}`}>
                      <h2 className="lable">
                        Project <span>:</span>
                      </h2>
                      <p className="value">{editSynergy?.projectName}</p>
                    </div>
                    <div className={`synergy-data ${activeSection ? "col-12" : "col-6"}`}>
                      <h2 className="lable">
                        Synergy Type <span>:</span>
                      </h2>
                      <p className="value">{editSynergy?.synergyTypeName}</p>
                    </div>
                    <div className={`synergy-data ${activeSection ? "col-12" : "col-6"}`}>
                      <h2 className="lable">
                        Priority <span>:</span>
                      </h2>
                      <p className="value">{editSynergy?.priorityName}</p>
                    </div>

                    <div className={`synergy-data ${activeSection ? "col-12" : "col-6"}`}>
                      <h2 className="lable">
                        Synergy Status <span>:</span>
                      </h2>
                      <p className="value">{editSynergy?.statusName}</p>
                    </div>
                    <div className={`synergy-data ${activeSection ? "col-12" : "col-6"}`}>
                      <h2 className="lable">
                        Reported User <span>:</span>
                      </h2>
                      <p className="value">{editSynergy?.reportedUser}</p>
                    </div>
                    <div className={`synergy-data ${activeSection ? "col-12" : "col-6"}`}>
                      <h2 className="lable">
                        Submitted Date <span>:</span>
                      </h2>
                      {/* <p className="value">{editSynergy?.submittedDate}</p> */}
                      <p className="value">
                        {editSynergy?.submittedDate
                          ? formatDate(editSynergy.submittedDate, "DD/MM/YYYY")
                          : "N/A"}
                      </p>
                    </div>
                  </div>
                </div>


                <div className="synergy-content-card">
                  <h2 className="lable">
                    Description<span>:</span>
                  </h2>
                  <div className="edit-synergytaskdescription-icon">
                    <button
                      type="submit"
                      className="btn edit-btn view"
                      onClick={handleOpenCenterPopup}
                    >
                      <Iconify icon="mdi:eye" />
                    </button>
                    <button
                      type="submit"
                      className="btn edit-btn"
                      onClick={EditSynergyOpenPopup}
                    >
                      <Iconify icon="line-md:pencil" />
                    </button>
                  </div>
                  <div
                    className="image-container"
                    dangerouslySetInnerHTML={{ __html: editSynergy?.description }}
                  ></div>
                </div>


                {/* User Story Details */}
                {editSynergy?.synergyTypeID === 3 ? (
                  <>
                    <div className="synergy-content-card">
                      <div className="synergy-data">
                        <h2 className="lable">User Goal :</h2>
                        <p className="value">{editSynergy?.userGoal}</p>
                      </div>
                    </div>
                    <div className="synergy-content-card">
                      <div className="synergy-data">
                        <h2 className="lable">Benefit :</h2>
                        <p className="value">{editSynergy?.benefit}</p>
                      </div>
                    </div>
                    <div className="synergy-content-card">
                      <div className="synergy-data">
                        <h2 className="lable">Acceptance Criteria :</h2>
                        <p
                          className="value"
                          dangerouslySetInnerHTML={{
                            __html: editSynergy?.acceptanceCriteria,
                          }}
                        ></p>
                      </div>
                    </div>
                    {/* <div className="synergy-content-card">
                      <div className="synergy-data">
                        <h2 className="lable">User Story :</h2>
                        <p className="value">
                          {editSynergy?.userStory || "N/A"}
                        </p>
                      </div>
                    </div> */}
                    <div className="synergy-content-card">
                      <div className="synergy-data">
                        <h2 className="lable">
                          Proposed User <span>:</span>
                        </h2>
                        <p className="value">{editSynergy?.reportedUser}</p>
                      </div>

                    </div>
                  </>
                ) : null}


                {editSynergy?.synergyTypeID === 1 ? (
                  <>
                    <div className="synergy-content-card">
                      <div className="synergy-data">
                        <h2 className="lable">Business Value :</h2>
                        <p className="value">{editSynergy?.businessValue}</p>
                      </div>
                    </div>

                    <div className="synergy-content-card">
                      <div className="synergy-data">
                        <h2 className="lable">Expected Outcomes :</h2>
                        <p className="value">{editSynergy?.expectedOutcomes}</p>
                      </div>
                    </div>

                    <div className="synergy-content-card">
                      <div className="synergy-data">
                        <h2 className="lable">Considerations :</h2>
                        <p className="value">{editSynergy?.considerations}</p>
                      </div>
                    </div>
                  </>
                ) : null}



                {editSynergy?.synergyTypeID === 2 ? (
                  <>
                    <div className="synergy-content-card normal-form">
                      <div className="synergy-data">
                        <h2 className="lable">
                          Affected Modules <span>:</span>
                        </h2>
                        <p className="value">{editSynergy?.projectModules}</p>
                      </div>
                      <div className="synergy-data">
                        <h2 className="lable">
                          Change Request <span>:</span>
                        </h2>
                        {/* <p className="value">Enter Change Request Here</p> */}
                        <p className="value">
                          {editSynergy?.autoGeneratedCRNumber || "N/A"}
                        </p>
                      </div>

                    </div>
                    <div className="synergy-content-card">
                      <div className="synergy-data">
                        <h2 className="lable">Reason For Change :</h2>
                        <p className="value">{editSynergy?.reasonForChange}</p>
                      </div>
                    </div>
                  </>
                ) : null}
              </div>
            </div>
          </div>
          <div className="edit-synergy-attachment-section">
            <div className="synergy-attachments-section">
              <div className="row">
                <SynergyAttachments synergyId={synergyId} />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={`right-section ${activeSection ? "visible" : ""}`}>
        <div className="right-section-body">
          <button className="close-btn" onClick={handleClose}>
            <Iconify icon="mingcute:close-line" />
          </button>
          {activeSection === "comment" && (
            <div className="synergy-comment-section">
              <SynergyComments synergyId={synergyId} />
            </div>
          )}
          {activeSection === "task" && (
            <div className="synergy-task-section">
              <SynergyTasks synergyId={synergyId} />
            </div>
          )}
        </div>
      </div>
      <CenterModel
        showModal={showCenterPopup}
        className="view-description-center-modal"
        handleToggleModal={closeCenterPopup}
        modalTitle={isEditing ? 'Edit Synergy Description' : 'View Synergy Description'}
        modelSizeClass="w-85"
      >

        {
          isEditing ? (
            <SynergyDescription
              editsynergy={editSynergy?.description}
              closePopup={EditSynergyClosePopup}
              updatedCommit={handleSaveDescription}
              synergyId={synergyId}
            />
          ) :
            <div dangerouslySetInnerHTML={{ __html: editSynergy?.description }}></div>
        }

      </CenterModel>
    </div>
  );
};

export default EditSynergy;
